import { Team } from "../../types";

export const lplTeams: Team[] = [
  {
    name: "BLG",
    icon: "https://am-a.akamaihd.net/image?resize=60:60&f=http%3A%2F%2Fstatic.lolesports.com%2Fteams%2F1682322954525_Bilibili_Gaming_logo_20211.png",
    seed: 1,
  },
  {
    name: "JDG",
    icon: "https://am-a.akamaihd.net/image?resize=60:60&f=http%3A%2F%2Fstatic.lolesports.com%2Fteams%2F1627457924722_29.png",
    seed: 2,
  },
  {
    name: "LNG",
    icon: "https://am-a.akamaihd.net/image?resize=60:60&f=http%3A%2F%2Fstatic.lolesports.com%2Fteams%2F1631819402484_lng-2021-worlds.png",
    seed: 3,
  },
  {
    name: "TES",
    icon: "https://am-a.akamaihd.net/image?resize=60:60&f=http%3A%2F%2Fstatic.lolesports.com%2Fteams%2F1592592064571_TopEsportsTES-01-FullonDark.png",
    seed: 4,
  },
  {
    name: "OMG",
    icon: "https://am-a.akamaihd.net/image?resize=60:60&f=http%3A%2F%2Fstatic.lolesports.com%2Fteams%2F1686821355861_OMG_2023_logo-01.png",
    seed: 5,
  },
  {
    name: "WBG",
    icon: "https://am-a.akamaihd.net/image?resize=60:60&f=http%3A%2F%2Fstatic.lolesports.com%2Fteams%2F1641202879910_3.png",
    seed: 6,
  },
  {
    name: "RNG",
    icon: "https://am-a.akamaihd.net/image?resize=60:60&f=http%3A%2F%2Fstatic.lolesports.com%2Fteams%2F1631819360134_rng-2021-worlds.png",
    seed: 7,
  },
  {
    name: "EDG",
    icon: "https://am-a.akamaihd.net/image?resize=60:60&f=http%3A%2F%2Fstatic.lolesports.com%2Fteams%2F1631819297476_edg-2021-worlds.png",
    seed: 8,
  },
  {
    name: "WE",
    icon: "https://am-a.akamaihd.net/image?resize=60:60&f=http%3A%2F%2Fstatic.lolesports.com%2Fteams%2F1634763008788_220px-Team_WE_logo.png",
    seed: 9,
  },
  {
    name: "NIP",
    icon: "https://am-a.akamaihd.net/image?resize=60:60&f=http%3A%2F%2Fstatic.lolesports.com%2Fteams%2F1673425724696_NIP-Symbol-RGB-NeonYellow1.png",
    seed: 10,
  },
];
